export enum WeeklyDatepickerDataHooks {
  Main = 'weekly-datepicker-container',
  WeeklyDatepicker = 'weekly-datepicker',
}
